import type { AutomationExecutionResponse } from "@redotech/effect-api-shared/rpc/automation-execution";
import { useRequiredContext } from "@redotech/react-util/context";
import { EffectApiClientContext } from "@redotech/redo-merchant-app-common/effect-api-client-provider";
import { useQuery } from "@tanstack/react-query";
import { Effect } from "effect";

export function useAutomationExecution(workflowId: string | null) {
  const effectApi = useRequiredContext(EffectApiClientContext);

  return useQuery({
    queryKey: ["automationExecution", workflowId],
    queryFn: async (): Promise<AutomationExecutionResponse | null> => {
      if (!workflowId) return null;

      const client = effectApi.getClient();
      return effectApi.runPromise(
        client.automationExecution
          .getByWorkflowId({ path: { workflowId } })
          .pipe(Effect.orDie),
      ) as Promise<AutomationExecutionResponse | null>;
    },
    enabled: !!workflowId,
  });
}
